import React from 'react';
import PlotCard from '../PlotCard';

const YearCard = ({
  seriesEnergy,
  seriesPeakPower,
}) => {
  return (
    <PlotCard
      cardTitle={"Last 12 months"}
      cardSubtitle={"Monthly production and peak power"}
      seriesEnergy={seriesEnergy}
      seriesPeakPower={seriesPeakPower}
      binMs={30 * 24 * 3600 * 1000}
      windowMs={365 * 24 * 3600 * 1000}
    />
  )
}

export default YearCard;
